import {createRouter, createWebHashHistory} from 'vue-router'
import dbUtils from '@/utils/strotage.js'
import {getToken} from "@/utils/common";
import {useAuthStore} from "@/stores/auth";
import NProgress from 'nprogress' // progress bar
import '@/components/NProgress/nprogress.scss'
import pages from "@/router/pages";
import {addDynamicsRouter} from "@/router/tool";

NProgress.configure({showSpinner: false}) // NProgress Configuration

const router = createRouter({
    history: createWebHashHistory(),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {x: 0, y: 0};
        }
    },
    routes: pages, // `routes: routes` 的缩写
})

// 路由守卫
let registerRouteFresh = true // 定义标识，记录路由是否添加
router.beforeEach(async (to, from, next) => {
    NProgress.start() // start progress bar

    const authStore = useAuthStore()
    const isLoggedIn = getToken()
    const cacheMenus = dbUtils.get('menus')
    // 如果首次或者刷新界面，next(...to, replace: true)会循环遍历路由，如果to找不到对应的路由那么他会再执行一次beforeEach((to, from, next))直到找到对应的路由，
    // 我们的问题在于页面刷新以后异步获取数据，直接执行next()感觉路由添加了但是在next()之后执行的，所以我们没法导航到相应的界面。这里使用变量registerRouteFresh变量做记录，直到找到相应的路由以后，把值设置为false然后走else执行next(),整个流程就走完了，路由也就添加完了。
    if (registerRouteFresh && isLoggedIn && cacheMenus && cacheMenus.length) {
        addDynamicsRouter(router, cacheMenus)
        next(to.path)
        registerRouteFresh = false
        return;
    }

    // 检查是否需要登录
    if (to.meta.requiresAuth) {
        // 检查用户是否已经登录
        if (isLoggedIn) {
            // 已经登录 访问登录页则直接跳到主页
            if (to.name === 'login') {
                next('/');
                NProgress.done()
                return;
            }
            if (authStore.user === null) {
                await authStore.getUserDetail()
            }
            const menus = authStore.user && authStore.user.menus || [];
            // 如果还未找到缓存的权限数组则返回登录页
            if (!menus || !menus.length) {
                // 清空所有缓存数据
                dbUtils.clear()
                // 重定向到登录页
                next(`/login?redirect=${to.path}`)
                NProgress.done()
                return;
            }
            if (router.hasRoute(to.name)) {
                if (authStore.options === null) {
                    await authStore.getOptionList()
                }
                // 有权限直接访问
                next();
                NProgress.done()
                return;
            }

            // 无权限则重定向到401
            next({name: '401'});
            NProgress.done()
            return;
        }
        // 未登录
        // 清空所有缓存数据
        dbUtils.clear()
        // 重定向到登录页
        return next(`/login?redirect=${to.path}`)
    }
    // 无需登录的页面 直接访问即可
    next();
    NProgress.done()
});

router.afterEach((to) => {
    let title = process.env.VUE_APP_NAME + '后台管理系统'
    if (to.meta && to.meta.title) {
        title = to.meta.title + ' - ' + title
    }
    window.document.title = title;
    NProgress.done()
})

router.onError((error) => {
    // 在这里处理路由错误
    console.error('路由错误:', error);
});

export default router